import {useEffect, useState} from 'react';
import {getPhotoPicker, PHOTO_PICKER_MODEL} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import HandleChange from '../../../../../Helpers/HandleChange';
import {useTranslation} from 'react-i18next';
import {TYPE_PAYMENT} from '../Model/Model';
import {
    CreatePaymentEvidence, GetFinesTrafficDetails,
    RegisterFinePaid
} from '../../../../../reduxToolkit/Traffic/TrafficApi';
import {useDispatch, useSelector} from 'react-redux';
import {errorMsg, isBeforeToday} from '../../../../../Apis/functions';
import {toast} from 'react-toastify';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const PaymentModalApp = ({paymentTypeSelect, setShowConfirmationPay, onHide, setModified}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {finesTrafficDetails: trafficData} = useSelector((state) => state?.TrafficSlice);

    const [photoPicker, setPhotoPicker] = useState({...PHOTO_PICKER_MODEL});
    const [disabled, setDisabled] = useState(false);
    const [item, setItem] = useState({description: null});
    const [emptyFields, setEmptyFields] = useState(false);
    const [emptyDescription, setEmptyDescription] = useState(false);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [isPaid, setIsPaid] = useState(0);

    /**
     * Function to register the payment; depending on the type, it checks which fields are mandatory.
     */
    const handleConfirm = () => {
        const imageProfile = getPhotoPicker(photoPicker);
        const isImageEmpty = !imageProfile;
        const isDescriptionEmpty = !item?.description;

        if (paymentTypeSelect === TYPE_PAYMENT.CONDONATION) {
            if (isImageEmpty || isDescriptionEmpty) {
                setEmptyFields(true);
                setEmptyDescription(isDescriptionEmpty);
                return;
            }
        }

        if (paymentTypeSelect === TYPE_PAYMENT.NORMAL) {
            if (isImageEmpty) {
                setEmptyFields(true);
                return;
            }
        }

        const model = {
            fineId: trafficData.id,
            paymentType: paymentTypeSelect,
            description: item.description?.trim() === '' ? null : item.description,
        };

        let finePaymentId = trafficData?.finePaymentId;
        dispatch(RegisterFinePaid(model)).then(({ payload: { data: { data, code, message, success } } }) => {
            if(success){
                setModified(prev => prev+1);
                const file = getPhotoPicker(photoPicker);
                if (file != null && typeof file != 'undefined') {
                    handleCreateFile(finePaymentId, file);
                    setShowConfirmationPay(true);
                    onHide();
                    toast.success(t('has_been_payment_successfully'));
                    return;
                }
                setIsPaid(prev => prev+1);
                setShowConfirmationPay(true);
                onHide();
                toast.success(t('has_been_payment_successfully'));
            } else {
                errorMsg(code);
            }
        }); 
    }

    /**
     * Function to create payment evidences and obtain the payment update.
     * @param id
     * @param description
     * @param uploadFile
     */
    const handleCreateFile = async (id, uploadFile) => {
        const formData = new FormData();
        formData.append('finePaymentId', id);
        formData.append('fileUploadDto.files', uploadFile);
        formData.append('fileUploadDto.userFileNames', uploadFile?.name || '');
        formData.append('fileUploadDto.path',  '');
        await dispatch(CreatePaymentEvidence(formData));
        await dispatch(GetFinesTrafficDetails(trafficData.id))
    }

    useEffect(() => {
        if(trafficData?.id){
            dispatch(GetFinesTrafficDetails(trafficData.id));
        }
    }, [isPaid]);

    return {
        t,
        photoPicker, setPhotoPicker,
        disabled, setDisabled,
        item, setItem,
        emptyFields, setEmptyFields,
        handleChange,
        trafficData,
        handleConfirm,
        emptyDescription
    }
}

export default PaymentModalApp
